// API Urls
// export const API_URL = 'http://localhost:8080';
// export const BACKEND_SERVICE_API_URL = `${API_URL}/back-service/api/v1`;
// API Urls
export const API_URL = 'https://admin.gys.coalescets.com:3003'
export const BACKEND_SERVICE_API_URL = 'https://admin.gys.coalescets.com:3003/back-service/api/v1'

// export const USER_API_URL = 'http://localhost:5080'
export const USER_API_URL = 'https://app.gys.coalescets.com:4004'